import { render, staticRenderFns } from "./apiUserCreate.vue?vue&type=template&id=6071de58&scoped=true&"
import script from "./apiUserCreate.vue?vue&type=script&lang=ts&"
export * from "./apiUserCreate.vue?vue&type=script&lang=ts&"
import style0 from "./apiUserCreate.vue?vue&type=style&index=0&id=6071de58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071de58",
  null
  
)

export default component.exports